const routeApiApp = (clientId, path) => `/app/${clientId}${path}`;
const routeApiSystem = path => `/system${path}`;
const routeWebUser = (clientId, path) => `/${clientId}${path}`;
const routeWebAdmin = (clientId, path) => `/${clientId}/admin${path}`;

export { routeApiApp, routeApiSystem, routeWebUser, routeWebAdmin };
